import { render } from "./Main.vue?vue&type=template&id=39ddabbc&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Mainbubp.scss?vue&type=style&index=0&id=39ddabbc&lang=scss&scoped=true"
import "./Main.vue?vue&type=style&index=1&id=39ddabbc&lang=scss"
/* custom blocks */
import block0 from "./Main.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/var/www/briskly/brskl/products/business/app.prod.new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39ddabbc"]])

export default __exports__